import styled from "styled-components";

export const FreePlaySlideBox = styled.div`
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    font-weight: bold;
    font-size: 32px;
    background-color: ${props => props.theme.colors.backgroundLight};
    color: white;
`

